import { createSelector } from "reselect";

// Valores por defecto constantes para evitar crear nuevas referencias y loops infinitos
const EMPTY_OBJECT = {};
const EMPTY_ARRAY = [];

// Selector Base
const selectCompromisosState = (state) => state.dataCompromisos || EMPTY_OBJECT;

// Selectores del Estado
export const selectCompromisos = createSelector(
  selectCompromisosState,
  (state) => state.compromisos || EMPTY_ARRAY
);

export const selectCompromisosLoading = createSelector(
  selectCompromisosState,
  (state) => state.isLoading || false
);

export const selectGuardarCompromisoLoading = createSelector(
  selectCompromisosState,
  (state) => state.guardarCompromiso || false
);

export const selectErrorGuardadoCompromiso = createSelector(
  selectCompromisosState,
  (state) => state.errorCompromiso || null
);

export const selectBrokers = createSelector(
    selectCompromisosState,
    (state) => state.brokers || EMPTY_ARRAY
);

export const selectNuevoCompromiso = createSelector(
    selectCompromisosState,
    (state) => state.nuevoCompromiso || {
        brokerSolicitante: null,
        emailAsesor: "",
        tipoIdentificacion: null,
        numeroIdentificacion: ""
    }
);

export const selectConsultarClienteIsLoading =
    createSelector(
        selectCompromisosState,
        (state) =>
            state.consultarClienteIsLoading || false
    );